import pt from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

const DEFAULT_DATA_TRANSFORM_PLAYBOOK = {
  input: '',
  outputEvent: null,
  clusterId: '',
  hasValidInput: false,
  isLoading: false,
  playbook: null,
  outputErrors: null,
  setInput: () => {},
  setOutputEvent: () => {},
  setClusterId: () => {},
  setHasValidInput: () => {},
  setIsLoading: () => {},
  setOutputErrors: () => {},
};

const TransformPlaybookContextValue = createContext(DEFAULT_DATA_TRANSFORM_PLAYBOOK);

export const TransformPlaybookContextProvider = ({ playbook, children }) => {
  const [input, setInput] = useState('');
  const [outputEvent, setOutputEvent] = useState(null);
  const [clusterId, setClusterId] = useState('');
  const [hasValidInput, setHasValidInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [outputErrors, setOutputErrors] = useState(null);
  return (
    <TransformPlaybookContextValue.Provider
      value={{
        input,
        outputEvent,
        clusterId,
        hasValidInput,
        isLoading,
        playbook,
        outputErrors,
        setInput,
        setOutputEvent,
        setClusterId,
        setHasValidInput,
        setIsLoading,
        setOutputErrors,
      }}
    >
      {children}
    </TransformPlaybookContextValue.Provider>
  );
};

export const useTransformPlaybookContext = () => {
  return useContext(TransformPlaybookContextValue);
};

TransformPlaybookContextProvider.propTypes = {
  playbook: pt.object,
  children: pt.node.isRequired,
};
